import debug from "debug";
const log = debug("switchAttribute");

class SwitchAttribute {
	constructor(element, options = {}) {
		this.element = element;
		this.options = options;

		this.init();
	}

	init() {
		log('SwitchAttribute', this.element, this.options);

		if(!this.element.form) {
			log('No containing form found');
			return false;
		}

		this.element.form.addEventListener('change', this.handleChange.bind(this));
	}

	handleChange(event) {
		log('handleChange', event);

		const data = new FormData(this.element.form);

		if (!data.has(this.options.keyName)) {
			return false;
		}

		const formValue = data.get(this.options.keyName);
		log('formValue', formValue);

		const attrValue = this.valueLookup[formValue] !== undefined
			? this.valueLookup[formValue]
			: this.valueLookup["default"];

		this.setAttribute(attrValue || "");
	}

	get valueLookup() {
		return this.options.values.split(',').reduce(getKeyValue, {});

		function getKeyValue(keyValues, item) {
			const [key, value] = item.split(':');
			keyValues[key] = value || "";
			return keyValues;
		}
	}

	setAttribute(value) {
		this.element.setAttribute(this.options.attribute, value);
	}

	destroy() {
		this.element.form.removeEventListener('change', this.handleChange);
	}
}

SwitchAttribute.DEFAULTS = {
};

export default SwitchAttribute;



// WEBPACK FOOTER //
// ./client/src/core/modules/switch-attribute/switch-attribute.js